import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { GoodsListContext, useGoodsData } from './Context/GoodsListContext';

import { GoodsList } from './GoodsList/GoodsList';
import { HouseFIltersList } from './Filters/Houses/HouseFiltersList';
import { CategoryFIltersList } from './Filters/Categories/CategoryFiltersList';
import { SortersList } from './Sorters/SortersList';
import { SubscribeSection } from './SubscribeSection';
import { FiltersMenuIcon } from '../../Components/SvgComponents/FiltersMenuIcon';
import { CloseIcon } from '../../Components/SvgComponents/CloseIcon';

export const MainPage = () => {
  const { state } = useLocation();
  const [isFiltersOpen, setFiltersOpen] = useState(false);

  const { Provider } = GoodsListContext;
  const data = useGoodsData();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [state]);

  return (
    <Provider value={data}>
      <main className="w-full bg-body">
        <div className="px-2 smart:px-4 md:px-16 xl:px-24 py-2 smart:py-4 md:py-7 flex justify-between relative max-w-108 m-auto">
          <section
            className={[
              'absolute top-0 bg-white smart:bg-body w-full h-850 md:h-full smart:w-auto smart:static z-30 smart:z-20 flex flex-col md:basis-1/5 gap-2.5 items-center transition-all duration-300 ease-in',
              isFiltersOpen ? 'left-0' : 'left-[-530px]',
            ].join(' ')}>
            <h2 className="font-crimson font-bold text-lg md:text-xl leading-6 block tracking-wider text-center">
              Use to filter and sort ↓
            </h2>
            <div>
              <hr className="h-0.5 w-90 border-none bg-gradient-to-r from-grStart to-grEnd" />
              <HouseFIltersList houseState={state} />
              <hr className="h-0.5 w-90 border-none bg-gradient-to-r from-grStart to-grEnd" />
              <CategoryFIltersList />
              <hr className="h-0.5 w-90 border-none bg-gradient-to-r from-grStart to-grEnd" />
              <SortersList />
            </div>
          </section>
          <button
            className="absolute smart:static smart:hidden z-30"
            onClick={() => setFiltersOpen((isFiltersOpen) => !isFiltersOpen)}>
            {isFiltersOpen ? <CloseIcon /> : <FiltersMenuIcon />}
          </button>
          <section className="flex basis-full smart:basis-4/5 flex-col items-center gap-10 h-90VH mobile:h-80VH">
            <GoodsList />
          </section>
        </div>
        <SubscribeSection />
      </main>
    </Provider>
  );
};
